import _Promise from 'babel-runtime/core-js/promise';
import { crmMessagNumAPI } from '@/api/crm/message';

/**
 * 消息记录
 */
var app = {
  state: {
    // 待办事项消息
    messageNum: {
      todayCustomer: 0,
      followLeads: 0,
      followCustomer: 0,
      checkContract: 0,
      checkReceivables: 0,
      remindReceivablesPlan: 0,
      endContract: 0,
      totalNum: 0
    }
  },

  mutations: {
    /**
     * 更改待办事项
     */
    SET_MESSAGENUM: function SET_MESSAGENUM(state, messageNum) {
      var totalNum = 0;
      for (var key in messageNum) {
        if (key != 'totalNum') {
          totalNum += messageNum[key] || 0;
        }
      }
      messageNum.totalNum = totalNum;
      state.messageNum = messageNum;
    }
  },

  actions: {
    // 登录
    GetMessageNum: function GetMessageNum(_ref) {
      var state = _ref.state,
          commit = _ref.commit;

      return new _Promise(function (resolve, reject) {
        crmMessagNumAPI().then(function (response) {
          commit('SET_MESSAGENUM', response.data);
          commit('SET_CRMROUTERSNUM', state.messageNum.totalNum);
          resolve(response);
        }).catch(function (error) {
          reject(error);
        });
      });
    }
  }
};

export default app;